import { t } from 'i18next';
import { Text } from '@mantine/core';
import { Column, PatientReportsTable } from 'utils/models';
import { formatDate, calculateDaysBetweenDates } from 'utils/dates';
import { GroupBadge } from 'components/GroupBadge';
import { useAppContext } from 'context/hooks';
import { IndicatorLabel } from 'components/IndicatorLabel';
import { getReportIndicator } from 'utils/helpers';
import { DurationIcon } from '../../DurationIcon/DurationIcon';
import { DownloadReportActionIcon } from '../DownloadReportActionIcon';

export const PatientsReportsColumns = (): Column<PatientReportsTable>[] => {
  const { currentUser } = useAppContext();
  const renderGroupName = (groupId: string) => currentUser?.visibleGroups.find((group) => groupId === group.id)?.name;

  const columns: Column<PatientReportsTable>[] = [
    {
      header: t('reports_trigger'),
      width: 10,
      renderItem: (item) => <Text>{`${t(`reason_${item.trigger.toLowerCase()}`)}`}</Text>,
    },
    {
      header: t('reports_duration'),
      width: 10,
      renderItem: (item) => (
        <DurationIcon label={calculateDaysBetweenDates(item.content.startTimestamp, item.content.endTimestamp)} />
      ),
    },
    {
      header: t('reports_timestamp'),
      width: 15,
      renderItem: (item) => formatDate({ timestamp: item.creationTimestamp, formatWithTime: true }),
    },
    {
      header: t('reports_indicator'),
      width: 10,
      renderItem: (item) => <IndicatorLabel indicator={getReportIndicator(item.tags)} />,
    },
    {
      header: t('reports_status'),
      width: 10,
      renderItem: (item) => <Text>{`${t(`report_${item.status.toLocaleLowerCase()}`)}`}</Text>,
    },
    {
      header: t('reports_last_updated'),
      width: 15,
      renderItem: (item) => formatDate({ timestamp: item.updateTimestamp, formatWithTime: true }),
    },
    {
      header: t('reports_group'),
      width: 15,
      renderItem: (item) => <GroupBadge label={renderGroupName(item?.groupId)} groupId={item?.groupId} />,
    },
    {
      header: t('table_actions'),
      width: 5,
      renderItem: (item) => <DownloadReportActionIcon reportId={item.id} />,
    },
  ];

  return columns;
};
